import React, { memo, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { BrandArea } from '@xsolla/ui-core';

import { Error } from '../../../api/setup/getApiError';
import { PROJECT_LINKS } from '../../../constants';
import { useConfig } from '../../../contexts/config';
import { HorizontalCenterColumnBlock } from '../../../styled';
import { LinkStylesNoColor } from '../Link';
import errorsMap from '../NotificationList/errorsMap';
import { Footer, StyledAlert, StyledButton, StyledTitle, Text } from './style';

interface Props {
  title?: string;
  message?: string;
  error?: Error | null;
  onClick?: () => void;
  buttonText?: string;
  pageName?: string;
}

const PageError = ({
  onClick,
  error,
  message,
  title,
  buttonText,
  pageName
}: Props): JSX.Element => {
  const { xsollaAnalytics } = useConfig();
  const intl = useIntl();
  const { title: errorTitle = '', description: errorMessage = '' } = error
    ? errorsMap(intl, error, true)
    : {};
  const { DOCUMENTATION, CHAT, PARTNER_SUPPORT } = PROJECT_LINKS;

  useEffect(() => {
    xsollaAnalytics.sendOpen(`login_pa_module__${pageName}`, 'error', {
      errorMessage: message || ''
    });
  }, []);

  return (
    <BrandArea>
      <HorizontalCenterColumnBlock>
        <StyledAlert size={48} />

        {(title || errorTitle) && (
          <StyledTitle center indent="sm">
            {title || errorTitle}
          </StyledTitle>
        )}

        <Text>{message || errorMessage}</Text>

        {onClick && buttonText && <StyledButton onClick={onClick}>{buttonText}</StyledButton>}

        <Footer>
          {intl.formatMessage(
            { id: 'app.error.page.footer' },
            {
              doc: (chunk: string) => (
                <LinkStylesNoColor>
                  <a href={DOCUMENTATION} target="_blank" rel="noreferrer">
                    {chunk}
                  </a>
                </LinkStylesNoColor>
              ),
              help: (chunk: string) => (
                <LinkStylesNoColor>
                  <a href={PARTNER_SUPPORT} target="_blank" rel="noreferrer">
                    {chunk}
                  </a>
                </LinkStylesNoColor>
              ),
              chat: (chunk: string) => (
                <LinkStylesNoColor>
                  <a href={CHAT} target="_blank" rel="noreferrer">
                    {chunk}
                  </a>
                </LinkStylesNoColor>
              )
            }
          )}
        </Footer>
      </HorizontalCenterColumnBlock>
    </BrandArea>
  );
};

export default memo(PageError);
